
import { copyTextToClipboard, numberFormat } from '@/util';
import { BIZ_REMIND_ORDER } from '@/common';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { getOrderStatusLable } from '@/util/shop';
import OrderPaymentDialog from '@/page/userInfo/my-order/components/order-payment-dialog';
import OrderCancelDialog from '@/page/userInfo/my-order/components/order-cancel-dialog';
// OrderLogisticsDialog 已移至 index.vue 内联实现

import { list, receive, cancel } from "@/api/order/order.js"
import { replace } from 'lodash';

export default {

    components: {
        OrderPaymentDialog,
        OrderCancelDialog,
    },

    mounted() {
    },

    data() {
        return {
            orderId: this.data?.id || this.$route.query?.orderId,
            currentOrderInfo: {},
            loading: false,
            paymentDialogVisible: false,
            cancelDialogVisible: false,
            queryButton: {
                key: "queryButton",
                text: this.$t('message.home.Checkorder'/** 查看订单 */),
                func: () => {
                    localStorage.setItem('orderStatus', this.data.sellerStatus);
                    this.$router.push({ name: 'order-detail', query: { orderId: this.orderId } })
                }
            },
            payButton: {
                // payment
                key: "payButton",
                text: this.$t('message.home.order.payment'/** 立即付款 */),
                activity: true,
                func: () => {
                    this.paymentDialogVisible = true
                }
            },
            sendInfoButton: {
                key: "sendInfoButton",
                text: this.$t('message.home.RemindShip'/**提醒发货 */),
                func: this.remindOrder,

                // func: () => { }
            },

            confirmButton: {
                key: "confirmButton",
                text: this.$t('message.home.order.confirm' /**确认收货 */),
                func: this.order_receive,
            },
            cancelButton: {
                key: "cancelButton",
                text: this.$t('message.home.cancelOrder',/**取消订单 */),
                func: this.order_remove,
            },
            returnPayButton: {
                key: "returnPayButton",
                text: this.$t('message.home.returnApply',/**退款申请 */),
                func: () => {
                    this.$router.push({ name: 'order-return', params: { currentOrder: this.currentOrderInfo } })
                }
            },
            reBuyButton: {
                key: "reBuyButton",
                text: this.$t('message.home.rebuy'/**再来一单*/),
                func: () => { }
            },
            evaluateButton: {
                key: "evaluateButton",
                text: this.$t('message.home.order.evaluate'/**立即评价*/),
                func: () => {
                    this.$router.push({ name: 'order-evaluation', query: { orderId: this.currentOrderInfo.id } })
                }
            },
            queryLogisticsButton: {
                key: "queryLogisticsButton",
                text: this.$t('message.home.order.logistics'/**查看物流 */),
                func: () => {
                    this.$emit('show-logistics', this.data)
                }
            }
        }
    },
    computed: {
        // ...mapGetters('order', ['remindList']),
    },
    methods: {
        ...mapActions({
            requestOrderCancel: 'order/requestOrderCancel',
            requestOrderReceipt: 'order/requestOrderReceipt',
            requestOrderReturn: 'order/requestOrderReturn',
        }),
        ...mapMutations({
            updateRemindList: 'order/updateRemindList'
        }),
        closePayDialog() {
            this.paymentDialogVisible = false
        },
        goBack() {
            this.$router.go(-1)
        },
        remindOrder() {
            const orderId = this.orderId
            if (!this.remindList.includes(orderId)) {
                this.$confirm(this.$t('message.home.remindContent'), this.$t('message.home.remindTitle'), {
                    confirmButtonText: this.$t('message.home.btnSure'),
                    cancelButtonText: this.$t('message.home.cancel'),
                    type: 'warning',
                }).then(() => {
                    this.remindLoading = true
                    // setTimeout(() => {
                    //     this.remindList.push(orderId);
                    //     this.updateRemindList(this.remindList);
                    //     localStorage.setItem(BIZ_REMIND_ORDER, JSON.stringify(this.remindList))
                    //     this.$notify({
                    //         title: this.$t("message.home.successTips"),
                    //         message: this.$t("message.home.remindSuccess"),
                    //         type: "success",
                    //     });
                    //     this.remindLoading = false
                    // }, 1000)
                })
            } else {
                this.$message.warning(this.$t('message.home.remindRepeat'))
            }
        },
        // 确认收获
        receiptOrder() {
            this.$confirm(this.$t('message.home.confirmReceiveGoods'), this.$t('message.home.hint'), {
                confirmButtonText: this.$t('message.home.confirm'),
                cancelButtonText: this.$t('message.home.cancel'),
                type: 'warning',
            })
                .then(async () => {
                    try {
                        this.receiptLoading = true;
                        await this.requestOrderReceipt({ orderId: this.orderId });
                        this.refresh && this.refresh();
                        this.$notify({
                            title: this.$t('message.home.successTips'),
                            message: this.$t('message.home.operationSuccess'),
                            type: 'success',
                        });
                        this.closeDetails()
                    } finally {
                        this.receiptLoading = false;
                    }
                })
                .catch(() => { });
        },
        copy() {
            copyTextToClipboard(this.orderId);
            this.$notify({
                title: this.$t('message.home.successTips'),
                message: this.$t('message.home.copySuccess'),
                type: 'success',
            });
        },
        numberFormat,
        getOrderStatusLable,



        ///////////////////////////////////////////////////////////////////////////////////////////

        //取消订单
        order_remove: function (id) {
            var that = this;
            const orderId = this.orderId
            this.$confirm(this.$t('message.home.cancelOrder'), this.$t('message.home.cancelOrder'), {
                confirmButtonText: this.$t('message.home.btnSure'),
                cancelButtonText: this.$t('message.home.取消'),
                type: 'warning',
            }).then(() => {
                cancel({
                    "orderId": orderId
                }).then(response => {
                    this.refresh && this.refresh("2", "PENDING_PAYMENT");

                    this.$notify({
                        title: this.$t('message.home.successTips'),
                        message: this.$t('message.home.operationSuccess'),
                        type: 'success',
                    });
                    // if (this.$router)
                    //     this.goBack();
                    this.$router.push({ path: "/userInfo/my-order", replace: false });
                }).catch(error => {
                    console.error("error", error);
                })
            })
        },
        //确认收货
        order_receive: function () {

            this.$confirm(this.$t('message.home.confirmReceiveGoods'), this.$t('message.home.hint'), {
                confirmButtonText: this.$t('message.home.confirm'),
                cancelButtonText: this.$t('message.home.cancel'),
                type: 'warning',
            }).then(async () => {

                receive({
                    "orderId": this.orderId
                }).then(response => {
                    this.refresh && this.refresh("3", "SHIPPED");
                    this.$notify({
                        title: this.$t('message.home.successTips'),
                        message: this.$t('message.home.operationSuccess'),
                        type: 'success',
                    });
                    if (this.$router){
                        this.goBack();
                    }                        
                }).catch(error => {
                    this.loading=false;
                    console.error("error", error);
                })

            }).catch((err) => {
                console.error(err);

            });

        },

        ///////////////////////////////////////////////////////////////////////////////////////////

    }
}